<template>
  <base-card dark="true" class="lg:max-w-lg">
    <div>
      <div class="flex items-center justify-between border-b py-2 mb-4">
        <template v-if="meter.comd_serial">
          <div class="text-lg">{{ meter.comd_serial }}</div>
          <span class="uppercase text-sm">{{ meter.comd_type }}</span>
        </template>
        <template v-else-if="meter.meter_serial">
          <div class="text-lg">{{ meter.meter_serial }}</div>
          <span class="uppercase text-sm">{{ meter.meter_type }}</span>
        </template>
      </div>
      <div class="flex items-center justify-between border-b py-2 my-2">
        <div class="text-sm font-semibold">
          {{ $t('mygwf.components.User.ReportState.last_readout') }}:
        </div>
        <div
          class="flex items-center"
          @click="lastEntryClicked(meterState.last_entry)"
          :class="meterState.last_entry ? 'cursor-pointer hover:text-primary-light' : ''"
        >
          <!-- <a></a> ? -->
          <a class="text-sm" v-if="meterState.last_entry">
            <!-- {{ $d(new Date(new Date(meterState.last_entry).toUTCString().substr(0, 25)), 'long') }} -->
            {{ lastEntry }}
          </a>
          <span class="text-sm" v-else>-</span>
          <BaseIcon v-if="meterState.last_entry" icon="arrow-right" class="ml-1" />
        </div>
      </div>
      <div class="flex items-center justify-between border-b py-2 my-2">
        <div class="text-sm font-semibold">
          {{ $t('mygwf.components.User.ReportState.current_total_volume') }}:
        </div>
        <span class="text-sm" v-html="currentTotalVolume(meterState.volume)"></span>
      </div>
      <div
        v-if="meterState.battery_lifetime !== undefined"
        class="flex items-center justify-between border-b py-2 my-2"
      >
        <div class="text-sm font-semibold">
          {{ $t('mygwf.components.User.ReportState.battery_lifetime') }}:
        </div>
        <div class="flex items-center">
          <span class="text-sm mr-2">{{
            `${meterState.battery_lifetime} ${$t('mygwf.components.User.ReportState.semesters')}`
          }}</span>
          <base-icon
            :class="[
              'text-xl',
              meterState.battery_lifetime < 4 ? 'text-red-light' : 'text-green-light',
            ]"
            :icon="meterState.battery_lifetime < 4 ? `battery-0` : `battery-5`"
          />
        </div>
      </div>
      <div class="flex flex-col py-2 my-1">
        <div class="flex flex-row justify-between text-sm mb-3">
          <span class="font-semibold">{{ $t('mygwf.components.User.ReportState.alerts') }}:</span>
        </div>
        <div v-if="alertsArray && alertsArray.length > 0">
          <div v-for="alert in alertsArray" :key="alert">
            <div
              class="text-sm bg-white shadow-sm flex flex-1 items-center justify-between p-2 my-1"
            >
              <div class="flex flex-col">
                <div class="flex flex-row space-x-2">
                  <base-icon class="text-xl text-orange-light" icon="info" />
                  <span>{{ alertText(alert) }}</span>
                  <base-icon
                    v-if="alertDesc(alert) !== ''"
                    class="self-center text-xs"
                    icon="info"
                    v-tooltip="{
                      content: alertDesc(alert),
                    }"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <p class="text-sm bg-white shadow-sm flex flex-1 items-center p-2 my-1">
            <base-icon class="text-xl text-green-light mr-2" icon="success" />
            <span>{{ $t('mygwf.components.Label.no_alerts') }}</span>
          </p>
        </div>
      </div>
    </div>
  </base-card>
</template>

<script>
import {BaseCard, BaseIcon, BaseLoader} from '@/components/base'
import {format} from 'date-fns/esm'

export default {
  data() {
    return {
      meterState: {},
      alertsArray: [],
    }
  },
  props: {
    meter: {
      type: Object,
      default: null,
    },
  },
  computed: {
    lastEntry() {
      return format(new Date(this.meterState.last_entry), 'LLL dd, yyyy HH:mm')
    },
  },
  methods: {
    componentInit() {
      this.meterState = this.meter.state
      Object.keys(this.meterState)
        .filter(key => !['last_entry', 'volume', 'battery_lifetime', 'alertCount'].includes(key))
        .forEach(key => {
          if (this.meterState[key] !== false) {
            this.alertsArray.push(key)
          }
        })
    },

    alertText(key) {
      return this.$t(`mygwf.components.User.ReportState.${key}`)
    },
    alertDesc(key) {
      return this.$te(`mygwf.components.User.ReportState.${key}.description`)
        ? this.$t(`mygwf.components.User.ReportState.${key}.description`)
        : ''
    },
    currentTotalVolume(vol) {
      return vol !== '0.000000'
        ? `${new Intl.NumberFormat(this.$i18n.locale).format(vol)} m<sup>3</sup>`
        : '-'
    },

    lastEntryClicked(lastEntry) {
      this.$root.$emit('lastEntryClicked', lastEntry.substr(0, 10))
    },
  },
  components: {
    BaseCard,
    BaseIcon,
    BaseLoader,
  },
  watch: {
    meter: {
      immediate: true,
      handler(n) {
        this.alertsArray = []
        this.componentInit()
      },
    },
  },
}
</script>
